// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"557":"e1e357ed","729":"aeb223d4"}[chunkId] + ".chunk.css";
};